import chroma from 'chroma-js';

import { EPaletteModes } from '@/types/theme-packs.types';

const memoMap = new Map<string, EPaletteModes>();

const isColorLightOrDark = (hex: string): EPaletteModes => {
  const known = memoMap.get(hex);
  if (known) return known;

  // make sure chroa doesn't crash the app with invalid hex
  if (!chroma.valid(hex)) {
    console.warn('isColorLightOrDark: invalid hex', hex);
    memoMap.set(hex, EPaletteModes.Light);
    return EPaletteModes.Light;
  }
  // I find that the luminance check is not always accurate for determining light or dark
  // so using the lab lightness value with an estimated threshold of 70 which seems to work a little better in certain cases.
  // However, keeping it around just in case we find issues with this method
  // return chroma(hex).luminance() > 0.5 ? EPaletteModes.Light : EPaletteModes.Dark;
  const res = chroma(hex).get('lab.l') < 70 ? EPaletteModes.Dark : EPaletteModes.Light;
  memoMap.set(hex, res);
  return res;
};

export default isColorLightOrDark;
